const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const loopMap = require('mn-utils/loopMap');
const map = require('mn-utils/map');
const {
  apiRequestAdmin,
} = require('../ws');

import {
  ENDPOINT_ADMIN_KYC_LIST,
  ENDPOINT_ADMIN_KYC_DETAILS,
  ENDPOINT_ADMIN_KYC_UPDATE,
  ENDPOINT_ADMIN_KYC_DOWNLOAD
} from '../../constants/api';

const accounts$ = new Emitter(loopMap(100, (i) => ({
  id: '98690198-98bc-421a-ace4-e2fe5dd590eb' + i,
  company: 'Lunu Solution GmbH',
  login: 'Pavlo Denysuk',
  role: 'merchant',
  lifeflow: 'need_email_confirmation',
  blocked: false,
  verification_state: 'not_submitted',
  verification_message: 'verification message',
  updated_at: '2021-03-31',
})));


export function apiAdminAccountsKYCList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  return apiRequestAdmin(ENDPOINT_ADMIN_KYC_LIST, {
    ...params,
    offset,
    limit,
  }, () => {
    const items = accounts$.getValue();
    return {
      list: items.slice(offset, offset + limit),
      count: items.length,
    };
  });
}

export function apiAdminAccountsKYCGet(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_KYC_DETAILS, params);
}


export function apiAdminKYCVerificationStateUpdate(params) {
  params = params || {};
  const accountId = params.account_id;
  const verificationState = params.verification_state;
  const verificationMessage = params.verification_message || '';
  if (process.env.MOCK) {
    accounts$.emit(map(accounts$.getValue(), (v) => {
      return v.id === accountId ? {
        ...v,
        verification_state: verificationState,
        verification_message: verificationMessage,
      } : v;
    }, []));
    return CancelablePromise.delay(500, {});
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_KYC_UPDATE, {
    ...params,
    account_id: accountId,
    verification_state: verificationState,
    /*
      * "not_submitted" - Пользователь должен загрузить данные и документы.
      * Заменено на "pending" - мерчант должен предоставить/обновить данные.
      *
      * "submitted" - Пользователь говорит, что документы готовы к проверке.
      * "approved" - Проверка завершена, пользователь допущен к работе.
      * "rejected" - Проверка завершена, пользователь отклонён
        - причина в compliance.
    */

    verification_message: verificationMessage,
  });
}

export function getKYCDocDownloadLinkById(id) {
  /*
    Получение ранее загруженного файла

    * doc_id (Uuid) - id документа.

    В ответ должен быть получен файл, с указанными
      при аплоуде content-type и именем файла.
  */
  return ENDPOINT_ADMIN_KYC_DOWNLOAD + '/' + id;
}
